<mat-card>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "labor_utilization_report.search_information" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form
          #f="ngForm"
          [formGroup]="searchLaborReportForm"
          (ngSubmit)="onClickBtnFilter()"
          class="pb-3"
        >
          <div class="row">
            <div class="col-4">
              <!-- Tên mẫu, mã mẫu hợp đồng văn bản -->
              <mat-form-field class="w-100">
                <!-- <mat-label>{{'labor_utilization_report.template_name_or_code' | translate}}</mat-label> -->
                <input
                (focusout)="focusOut('nameOrCode')"
                  #focusInput
                  matInput
                  type="text"
                  [placeholder]="'document_template.lbl_name_or_code' | translate"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="nameOrCode"
                />
                <button
                  mat-button
                  *ngIf="searchLaborReportForm?.controls?.nameOrCode?.value"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('nameOrCode')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- Loại hợp đồng văn bản -->
              <mat-form-field class="w-100">
                <!-- <mat-label>{{'labor_utilization_report.document_contract_type' | translate}}</mat-label> -->
                <mat-select
                  id="status"
                  name="status"
                  formControlName="serviceType"
                  [placeholder]="'document_template.lbl_document_type' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchServiceTypeCtrl"
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [searching]="loadingSearch"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let document of listServiceTypeFilter | async"
                    [value]="document?.id"
                  >
                  {{ document?.name }}
                  </mat-option>
                </mat-select>
                <button
                  mat-button
                  *ngIf="searchLaborReportForm?.controls?.serviceType?.value"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('serviceType')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- trang thai -->
              <mat-form-field class="w-100">
                <mat-select id="status" name="status" [placeholder]="'document_template.lbl_status' | translate"
                  formControlName="statusEquals" (ngModelChange)="onClickBtnFilter()">
                  <mat-option value="null">
                    {{ "system_document_template.cbx_document_status.cbx_document_status_select_all" | translate }}
                  </mat-option>
                  <mat-option value="ACTIVE">
                    {{ "system_document_template.cbx_document_status.cbx_document_status_active" | translate }}
                  </mat-option>
                  <mat-option value="INACTIVE">
                    {{ "system_document_template.cbx_document_status.cbx_document_status_inactive" | translate }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="searchLaborReportForm?.controls?.statusEquals?.value" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="clearData('statusEquals')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button mat-stroked-button color="primary" type="submit">
                <mat-icon class="mr-0" style="font-weight: 900">
                  search
                </mat-icon>
                {{ "search_form.search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title
          class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center"
        >
          <span>
            {{ "labor_utilization_report.contract_template_list" | translate }} ({{paginate.totalRow}})
          </span>
          <button
            class="pull-right"
            mat-stroked-button
            color="primary"
            type="button"
            (click)="onClickCreateLaborReport()"
            [disabled]="commonService.getIsLockedEnterprise()"
          >
            <mat-icon class="mr-0">add_circle</mat-icon
            >{{ "labor_utilization_report.add_new" | translate }}
          </button>
        </mat-panel-title>
        <div>
          <mat-table [dataSource]="listDataSource" matSort>
            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "headertable.stt" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ paginate.currentPage * paginate.pageSize + i + 1 }}
              </mat-cell>
            </ng-container>
            <!-- Tên mẫu hợp đồng -->
            <ng-container matColumnDef="name">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "labor_utilization_report.contract_template_name" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltip(element.name, i, 'nameToolTip')"
                class="mat-cell-non-boder-right-bottom cell"
              >
                <span class="fix-width fw-100 name nameToolTip">{{ element.name }}</span>
              </mat-cell>
            </ng-container>
            <!-- Mã mẫu hợp đồng -->
            <ng-container matColumnDef="code">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "labor_utilization_report.contract_template_code" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltip(element.code, i, 'codeToolTip')"
                class="mat-cell-non-boder-right-bottom cell"
              >
                <span class="fix-width fw-100 code codeToolTip">{{ element.code }}</span>
              </mat-cell>
            </ng-container>
            <!-- Loại hợp đồng -->
            <ng-container matColumnDef="type">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "labor_utilization_report.contract_type" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltip(element.serviceTypeName, i, 'serviceTypeNameToolTip')"
                class="mat-cell-non-boder-right-bottom cell"
              >
              <span class="fix-width fw-100 serviceTypeName serviceTypeNameToolTip">{{ element.serviceTypeName }}</span>
              </mat-cell>
            </ng-container>
            <!-- Trạng thái -->
            <ng-container matColumnDef="status">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "labor_utilization_report.status" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="text-center mat-cell-non-boder-right-bottom cellStatus d-flex justify-content-center"
              >
                <div class="wrap-status">
                  <div *ngIf="element?.status">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#12B76A"/>
                    </svg>
                    <span class="ml-1" style="color: #027A48">{{"labor_utilization_report.active" | translate}}</span>
                  </div>
                  <div *ngIf="!element?.status">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#6B7280"/>
                    </svg>
                    <span class="ml-1" style="color: #3B3F46">{{"system_document_template.cbx_document_status.cbx_document_status_inactive" | translate}}</span>
                  </div>
                </div>
              </mat-cell>
            </ng-container>
            <!-- Thao tác -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="text-center">
                {{ "headertable.action_header" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center">
                <button
                  mat-icon-button
                  type="button"
                  (click)="editCategory(element.id)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <mat-icon
                    matTooltip="{{
                      'document_template.tooltip_edit' | translate
                    }}"
                    >mode_edit</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="deleteCategory(element)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <i
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    class="fa fa-trash"
                    style="font-size: 20px"
                    aria-hidden="true"
                    matTooltip="{{
                      'document_template.tooltip_delete' | translate
                    }}"
                  ></i>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="element-row"
            >
            </mat-row>
          </mat-table>

          <!-- Pagination -->
          <app-pagination
            [(paginate)]="paginate"
            (pageChange)="onPageChange($event.page, $event.pageSize)"
          >
          </app-pagination>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>